/**
 * NotFound — 404 catch-all page.
 * Rendered by App.js on any unmatched URL. Keeps the header/footer
 * chrome intact so users can navigate back without a blank screen.
 */
import { Link } from "react-router-dom";
import { ArrowLeft, Home, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <section
      data-testid="not-found-page"
      className="max-w-3xl mx-auto px-6 py-16 md:py-24 text-center"
      style={{ color: "var(--wofy-text)" }}
    >
      <div
        className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest px-3 py-1 rounded-full mb-6"
        style={{ background: "var(--wofy-accent-soft, #FDF3E7)", color: "var(--wofy-primary)" }}
      >
        404 · Page not found
      </div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold mb-4 leading-tight">
        We couldn't find that page.
      </h1>
      <p className="text-base md:text-lg opacity-80 mb-10 max-w-xl mx-auto">
        The link may have moved, or perhaps you followed a stale bookmark.
        The rest of the site is still here — try one of the quick jumps below.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          data-testid="not-found-home-cta"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold shadow-sm hover:opacity-90"
          style={{ background: "var(--wofy-primary)", color: "#FDFBF7" }}
        >
          <Home className="w-4 h-4" /> Back to home
        </Link>
        <Link
          to="/meet-the-founder"
          data-testid="not-found-founder-cta"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold border hover:bg-black/5"
          style={{ borderColor: "var(--wofy-border)", color: "var(--wofy-text)" }}
        >
          <Compass className="w-4 h-4" /> Meet the founder
        </Link>
        <button
          type="button"
          onClick={() => window.history.length > 1 ? window.history.back() : null}
          data-testid="not-found-back-cta"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold border hover:bg-black/5"
          style={{ borderColor: "var(--wofy-border)", color: "var(--wofy-text-soft, var(--wofy-text))" }}
        >
          <ArrowLeft className="w-4 h-4" /> Go back
        </button>
      </div>
    </section>
  );
}
